import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { readJournalAction,updateJournalAction } from '../../store/Languages/LanguageAction'; // adjust path
import JournalCard from './JournalCard';
import Modal from '../Addcurriculum/Modal';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation } from "react-router-dom";
import AllJournals from '../Journals/AllJournals';
import {fetchChurchesRequest} from "../../store/Churches/actions"
import { deleteJournalAction } from "../../store/Languages/LanguageAction";
import JournalModal from "../Journals/JournalsModal"
import {churchJournalSaveAction} from "../../store/Curriculum/CurriculumAction"
import CustomTable from '../../components/universal/CustomTable';
import ConfirmToast from '../../components/universal/ConfirmToast';
import { confirmAlert } from 'react-confirm-alert';
const JournalList = ({ church, typeofentity }) => {
  const dispatch = useDispatch();
  const [rowData, setRowData] = useState(null);

  const [allJournals, setAllJournals] = useState([]);
  const [selectedJournals, setSelectedJournals] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const limit = 12; // better UX for cards
  const totalPages = Math.ceil(totalRecords / limit);
  const location = useLocation();
  const [churchJournals, setChurchJournals] = useState([]);
// For select journal modal
const [isSelectModalOpen, setIsSelectModalOpen] = useState(false);

// For edit/create journal modal
const [isJournalModalOpen, setIsJournalModalOpen] = useState(false);

const handleNextPage = () => {
  if (page < totalPages) {
    setPage((prev) => prev + 1);
  }
};

const handlePrevPage = () => {
  if (page > 1) {
    setPage((prev) => prev - 1);
  }
};

  /** Fetch all journals */
  useEffect(() => {
    fetchJournals();
  }, [page]);

  const fetchJournals = (pageNumber = page) => {
    setLoading(true);
    dispatch(
      readJournalAction({
        apiPayloadRequest: {
          page: pageNumber,
          limit: limit,
        },
        callback: (res) => {
          if (res?.type === 1) {
                        setAllJournals(res.data || []);
            setTotalRecords(res.totalRecords || 0);
          }
          setLoading(false);
        },
      })
    );
  };


  const getEntityKey = (type) => {
    if (Number(type) === 2) return "channelObjId";
    if (Number(type) === 3) return "ministriesObjId";
    return "_id";
  };

  const handleSelectJournal = (journal) => {
    setSelectedJournals((prev) => {
      if (prev.some((item) => item._id === journal._id)) return prev;
      return [...prev, journal];
    });
    setIsSelectModalOpen(false);
  };

  const handleSaveSelected = async () => {
    if (!selectedJournals.length) return;

    try {
      await Promise.all(
        selectedJournals.map(
          (journal) =>
            new Promise((resolve, reject) => {
              dispatch(
                churchJournalSaveAction({
                  apiPayloadRequest: {
                    [getEntityKey(typeofentity)]: church?._id,           // Church/Channel/Ministry Obj ID
                    journalObjId: journal?._id, // Journal Obj ID
                  },
                  callback: (res) => {
                    if (res?.type === 1) {
                      resolve(res);
                    } else {
                      reject(res);
                    }
                  },
                })
              );

            })
        )
      );

      toast.success('All selected journals saved successfully!');
      setSelectedJournals([]); // optional: clear selection

      // ✅ Refresh church journals after saving
      if (church?._id) {
        dispatch(
          fetchChurchesRequest({
            apiPayloadRequest: {
              _id: church._id,
              typeofentity: typeofentity || 1
            },
            callback: (res) => {
              if (res?.type === 1) {
                const churchData = res?.data?.[0];
                setChurchJournals(churchData?.journals || []);
              }
            },
          })
        );
      }
    } catch (error) {
      toast.error('Failed to save some journals');
          }
  };

  useEffect(() => {
    if (!church?._id) return;

    dispatch(
      fetchChurchesRequest({
        apiPayloadRequest: {
          _id: church._id,
          typeofentity: typeofentity || 1
        },
        callback: (res) => {
          if (res?.type === 1) {
            const churchData = res?.data?.[0];
            setChurchJournals(churchData?.journals || []);
          }
        },
      })
    );
  }, [church?._id, typeofentity]);
  const handleDeleteJournal = (journal) => {
    dispatch(
      deleteJournalAction({
        apiPayloadRequest: {
          _id: journal._id,
        },
        callback: (res) => {
          if (res?.type === 1) {
            toast.success("Journal Deleted Successfully!");

            // remove from UI
            setChurchJournals((prev) =>
              prev.filter((item) => item._id !== journal._id)
            );
          } else {
            toast.error("Journal Failed To Delete!");
          }
        },
      })
    );
  };
  const journalTableHeaders = [
    { headerName: "Journal Title", headerId: "journal_title", width: "w-48" },
    { headerName: "Description", headerId: "journal_description", width: "w-64" },
    { headerName: "Created Date", headerId: "createdDate", width: "w-40" },
    { headerName: "Actions", headerId: "actions", width: "w-32" },
  ];
  const transformJournalTableData = (data = []) => {
    return data.map((item) => ({
      ...item,

      journal_title:
        typeof item.journal_title === "string"
          ? item.journal_title
          : "Untitled",

      journal_description:
        typeof item.journal_description === "string"
          ? item.journal_description
          : "No description",

      createdDate:
        item.createdDate && typeof item.createdDate === "string"
          ? new Date(item.createdDate).toLocaleDateString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
            })
          : "N/A",

      // 🔥 IDs used for actions (NOT rendered)
      churchJournalObjId: item._id,
      churchId: church?._id,
      typeofentity: typeofentity
    }));
  };

  return (
    <>
    <AllJournals church={church} selectedJournals={selectedJournals}/>
    {
    church?
    <div className="container mx-auto px-4 py-8">
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="flex justify-between items-center mb-8">
        <h1 className="text-xl font-bold text-gray-400">Selected Journals</h1>
        <div className="flex items-center gap-4">
        <button
  onClick={() => setIsSelectModalOpen(true)}
  className="text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl"
>
  Add Journal
</button>

          {selectedJournals.length > 0 && (
            <button
              onClick={handleSaveSelected}
              className="text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl"
            >
              Save Selected Journals
            </button>
          )}
        </div>
      </div>

      {selectedJournals.length === 0 ? (
        <p className="text-gray-500 text-center py-10">No journal selected</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-4">
          {selectedJournals.map((journal) => (
            <JournalCard key={journal._id} journal={journal} onClick={() => {}} />
          ))}
        </div>
      )}
{/* ================= CHURCH JOURNALS ================= */}
<div className="mt-12">
  <h2 className="text-xl font-bold text-gray-400 mb-6">
    Church Journals
  </h2>

  {churchJournals.length === 0 ? (
    <p className="text-gray-500 text-center py-10">
      No journals added to this church
    </p>
  ) : (

<CustomTable
  searchFor="Journals"
  heightDesktop="h-[60vh]"
  width="w-full"
  headers={journalTableHeaders}
  data={transformJournalTableData(churchJournals)}
  dataTransformer={transformJournalTableData}
  customDataFetch={false}
  reloadData={false}
  reverseTable={false}
  showSearch={true}
  searchPlaceholder="Search journals..."
  emptyStateMessage="No journals added to this church"

  handleEditClick={(row) => {
    setSelectedJournals([]); // prevent override
    setRowData(row);
    setIsJournalModalOpen(true);
  }}

  handleDeleteClick={(row) => {
    confirmAlert({
      customUI: ({ onClose }) => (
        <ConfirmToast
          title="Delete Journal"
          message={`Are you sure you want to delete "${row.journal_title}"? This action cannot be undone.`}
          onClose={onClose}
          onSuccess={() => {
            dispatch(
              deleteJournalAction({
                apiPayloadRequest: {
                  [getEntityKey(row.typeofentity)]: row.churchId,
                  _id: row.churchJournalObjId,
                },
                callback: (res) => {
                  if (res?.type === 1) {
                    toast.success("Journal deleted successfully!");

                    // 🔥 Update UI instantly
                    setChurchJournals((prev) =>
                      prev.filter(
                        (item) => item._id !== row.churchJournalObjId
                      )
                    );
                  } else {
                    toast.error("Failed to delete journal!");
                  }
                  onClose();
                },
              })
            );
          }}
        />
      ),
    });
  }}
/>

  )}
</div>

<Modal isOpen={isSelectModalOpen} onClose={() => setIsSelectModalOpen(false)}>
  <div className="space-y-6">
    <h2 className="text-xl font-bold text-gray-400">Select Journal</h2>

    {loading ? (
      <div className="flex justify-center py-10">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600" />
      </div>
    ) : (
      <>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-h-[60vh] overflow-y-auto">
          {allJournals.map((journal) => (
            <JournalCard
              key={journal._id}
              journal={journal}
              onClick={handleSelectJournal}
            />
          ))}
        </div>

        <div className="flex justify-between items-center pt-4">
          <button
            onClick={handlePrevPage}
            disabled={page === 1}
            className="px-4 py-2 text-sm border border-yellowish text-yellowish rounded disabled:opacity-40"
          >
            Previous
          </button>

          <span className="text-gray-400 text-sm">
            Page {page} of {totalPages}
          </span>

          <button
            onClick={handleNextPage}
            disabled={page === totalPages}
            className="px-4 py-2 text-sm border border-yellowish text-yellowish rounded disabled:opacity-40"
          >
            Next
          </button>
        </div>
      </>
    )}
  </div>
</Modal>

<JournalModal
  isOpen={isJournalModalOpen}
  onClose={() => setIsJournalModalOpen(false)}
  rowData={rowData}
  selectedJournals={selectedJournals}
/>


    </div>
    :
    <div className="w-full h-full flex items-center justify-center text-gray-400 ">
     <p>Add {Number(typeofentity) === 2 ? 'Channel' : Number(typeofentity) === 3 ? 'Ministry' : 'Church'} First</p>
     </div>
}
    </>
  );
};

export default JournalList;
